<script setup lang="ts">
const { deleteNumber, data } = useMobileNumberHandler();

const { $t, $trackEvent } = useNuxtApp();
const siteStore = useSiteStore();

const isLoading = ref<boolean>(false);

const confirmHandler = async () => {
  isLoading.value = true;
  const response = await deleteNumber(data.toDelete);
  isLoading.value = false;
  if (response?.isSuccessful) {
    siteStore.toggleSiteNotice({
      severity: 'success',
      heading: $t('success'),
      content: { data: $t(`pers-details-updated-succ`) },
      timeout: 3000,
      enabled: true,
    });
    siteStore.deactivateModal();
    $trackEvent('Account', 'MY_ACCOUNT_DELETE_SECONDARY_NUMBER');
  }
  data.toDelete = '';
};

const declineHandler = () => {
  data.toDelete = '';
  siteStore.deactivateModal();
};

onBeforeUnmount(() => {
  data.errorCode = '';
  data.errorRef = '';
  data.toDelete = '';
});
</script>

<template>
  <LazyUserInterfaceGenericLoader v-if="isLoading" :standalone="true" />
  <div v-else class="p-4 flex items-center justify-center">
    <UserInterfaceGenericError
      :state="data.errorCode ? 'danger' : 'warn'"
      class="max-w-72 mx-auto mb-2"
      :reference-code="data.errorRef"
      v-bind="{
        ...(data.errorCode && {
          'reference-code': data.errorRef,
        }),
      }"
    >
      {{
        data.errorCode
          ? $t(`update-details-${data.errorCode}`)
          : $t('acknowledge-delete-number')
      }}
    </UserInterfaceGenericError>
  </div>
  <div v-if="!isLoading" class="flex gap-4 p-4 bg-base w-full">
    <DesignSystemButton
      type="secondary-alternative"
      class="w-full justify-center"
      rounding="md"
      @click="declineHandler"
    >
      {{ $t('decline') }}
    </DesignSystemButton>
    <DesignSystemButton
      type="primary"
      class="w-full justify-center"
      rounding="md"
      @click="confirmHandler"
    >
      {{ $t('confirm') }}
    </DesignSystemButton>
  </div>
</template>
